import { render, staticRenderFns } from "./ActionConfirm.vue?vue&type=template&id=870d63d6&"
import script from "./ActionConfirm.vue?vue&type=script&lang=js&"
export * from "./ActionConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports